import axios from 'axios';
import { baseUrl } from './constants';

const STORAGE_VERSION = 'v1';

export const configureStorage = () => {
  const stored = localStorage.getItem('storageVersion');
  if (stored === STORAGE_VERSION) {
    return;
  }

  const cookie = localStorage.getItem('cookie-policy-result');

  localStorage.clear();
  sessionStorage.clear();

  if (cookie) {
    localStorage.setItem('cookie-policy-result', cookie);
  }

  localStorage.setItem('storageVersion', STORAGE_VERSION);
};

export const configureAxios = () => {
  axios.defaults.baseURL = baseUrl;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';
};
